export enum IconImageStatus {
  ACTIVE = 'active',
  RETIRED = 'retired',
}

export interface IIconImageData {
  id: number;
  name: string;
  title: string | null;
  imageUrl: string;
  status: IconImageStatus;
  usageCount: number;
  canDelete: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface UpdateIconImagePayload {
  id: number;
  title?: string;
  file?: File;
  lang: string;
}

export interface CreateIconImagePayload {
  name: string;
  title?: string;
  file: File;
  lang: string;
}

export interface IconLifecyclePayload {
  id: number;
  action: 'retire' | 'reactivate';
  lang: string;
}

export interface IIconImageFormData {
  name?: string;
  displayName: string;
  originalName?: string;
  file: File | null;
  lang: string;
  fileUrl?: string;
}

export interface IconImageApiResponse {
  data: IIconImageData[];
}
